module.exports = __webpack_public_path__ + "static/img/downFlo.516c245.png";


//////////////////
// WEBPACK FOOTER
// ./static/downFlo.png
// module id = SHVC
// module chunks = 1